import { ProductPageTemplate } from "@/components/ProductPageTemplate";
import { Shield, Users, Heart, FileText, Clock, Award } from "lucide-react";
import {getImageUrl} from '@/lib/utils';

const WorkersCompensation = () => {
  const pageData = {
    // SEO Meta Data
    title: "Workers' Compensation Insurance UAE | Employee Injury Coverage Dubai | YallaCompare",
    metaDescription: "Get workers' compensation insurance in UAE. Protect employees from workplace injuries in Dubai, Abu Dhabi & UAE. Compare workmen's compensation quotes online.",

    // Hero Section
    heroTitle: "Workers' Compensation Insurance for UAE Businesses",
    heroSubtitle: "Employee Protection Coverage",
    heroDescription: "Mandatory protection for your employees against workplace injuries and occupational diseases. Comprehensive coverage for medical expenses and compensation in the UAE.",
    heroImage: getImageUrl("workers-comp-icon.png"),

    // Key Benefits
    keyBenefits: [
      "Mandatory UAE legal compliance",
      "Medical expense coverage for employees",
      "Disability and compensation benefits",
      "Occupational disease protection",
      "Legal defense against employee claims",
      "Employer liability protection"
    ],

    // Features Section
    features: [
      {
        title: "Medical Coverage",
        description: "Comprehensive medical treatment coverage for workplace injuries and occupational diseases.",
        icon: <Heart className="h-6 w-6 text-blue-600" />
      },
      {
        title: "Employee Protection",
        description: "Complete protection for your workforce against workplace accidents and injuries.",
        icon: <Users className="h-6 w-6 text-blue-600" />
      },
      {
        title: "Legal Compliance",
        description: "Meet UAE mandatory workers' compensation requirements and avoid penalties.",
        icon: <FileText className="h-6 w-6 text-blue-600" />
      },
      {
        title: "Disability Benefits",
        description: "Compensation for temporary and permanent disability resulting from workplace injuries.",
        icon: <Shield className="h-6 w-6 text-blue-600" />
      },
      {
        title: "Quick Claims Processing",
        description: "Fast and efficient claims processing to ensure employees receive timely care.",
        icon: <Clock className="h-6 w-6 text-blue-600" />
      },
      {
        title: "Employer Protection",
        description: "Protection against employee lawsuits and liability claims related to workplace injuries.",
        icon: <Award className="h-6 w-6 text-blue-600" />
      }
    ],

    // Coverage Details
    coverageDetails: [
      {
        title: "Medical and Treatment Coverage",
        description: "Comprehensive medical care for workplace injuries",
        included: [
          "Emergency medical treatment",
          "Hospital and surgical expenses",
          "Rehabilitation and therapy",
          "Prescription medications",
          "Medical equipment and devices"
        ]
      },
      {
        title: "Compensation and Benefits",
        description: "Financial support for injured employees",
        included: [
          "Temporary disability benefits",
          "Permanent disability compensation",
          "Death benefits for families",
          "Occupational disease coverage",
          "Return-to-work programs"
        ]
      }
    ],

    // Why Choose Us
    whyChooseUs: [
      {
        title: "Legal Compliance",
        description: "Ensure full compliance with UAE labor laws and workers' compensation requirements"
      },
      {
        title: "Employee Welfare",
        description: "Demonstrate commitment to employee safety and well-being in the workplace"
      },
      {
        title: "Financial Protection",
        description: "Protect your business from costly employee injury claims and lawsuits"
      },
      {
        title: "Risk Management",
        description: "Access to workplace safety programs and risk reduction services"
      }
    ],

    // FAQ Section
    faqs: [
      {
        question: "Is workers' compensation insurance mandatory in the UAE?",
        answer: "Yes, workers' compensation insurance is mandatory for all employers in the UAE under the UAE Labor Law to protect employees from workplace injuries."
      },
      {
        question: "What types of injuries are covered?",
        answer: "Coverage includes all workplace injuries, occupational diseases, accidents during work hours, and injuries occurring on company premises or during work-related activities."
      },
      {
        question: "How are premiums calculated?",
        answer: "Premiums are based on industry risk level, number of employees, payroll amount, claims history, and workplace safety measures implemented."
      },
      {
        question: "What happens if an employee is injured at work?",
        answer: "The insurance covers medical treatment, rehabilitation costs, disability benefits, and compensation according to UAE labor law requirements."
      },
      {
        question: "Does it cover occupational diseases?",
        answer: "Yes, the policy covers occupational diseases that develop over time due to workplace conditions or exposure to hazardous materials."
      }
    ],

    // CTA Section
    ctaTitle: "Protect Your Employees Today",
    ctaDescription: "Ensure legal compliance and employee protection with comprehensive workers' compensation insurance. Get quotes from leading UAE insurers.",
    primaryCta: "Get Workers' Compensation Quote",
    secondaryCta: "Compare All Insurance Products",

    // Product ID for quote form
    productId: "workers-compensation"
  };

  return <ProductPageTemplate {...pageData} />;
};

export default WorkersCompensation;
